import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UiState } from './ui.reducer';

export const selectUiState = createFeatureSelector<UiState>('ui');

export const selectSidebarCollapsed = createSelector(
  selectUiState,
  (state) => state.sidebarCollapsed,
);
export const selectGlobalLoading = createSelector(selectUiState, (state) => state.globalLoading);
export const selectToast = createSelector(selectUiState, (state) => state.toast);
